import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class SkillsetRollupDemoService {

    constructor() {}

    GetRandomCallWaiting(def: number, min: number, max: number, dif: number) {
      return  new Date().getSeconds() % dif ? def : Math.floor(((Math.random() + min) * max) + 1);
    }
  
    get(location: string) {
        if (location.toUpperCase() === "NJ") {
            return of({
              Name: "Skillset Rollup - NJ",
              Location: "nj",
              LastUpdated: "",
              IsAlert: true,
              Items: [
                { Name: 'Group 1', CallsWaiting: this.GetRandomCallWaiting(4, 0, 5, 5), MaxWaitTime: "00:05:15", CallsAnswered: 1500, CallsAbandoned: 25, WarningLevel: 2, WarningTime: "" },
                { Name: 'Group 2', CallsWaiting: 1, MaxWaitTime: "00:02:10", CallsAnswered: 200, CallsAbandoned: 5, WarningLevel: 2, WarningTime: "" },
                { Name: 'Group 3', CallsWaiting: 1, MaxWaitTime: "00:01:18", CallsAnswered: 150, CallsAbandoned: 0, WarningLevel: 1, WarningTime: "" },
                { Name: 'Group 4', CallsWaiting: 0, MaxWaitTime: "00:00:00", CallsAnswered: 250, CallsAbandoned: 1, WarningLevel: 0, WarningTime: "" },
                { Name: 'Group 5', CallsWaiting: 0, MaxWaitTime: "00:00:00", CallsAnswered: 50, CallsAbandoned: 1, WarningLevel: 0, WarningTime: "" },
                { Name: 'Group 6', CallsWaiting: 0, MaxWaitTime: "00:00:00", CallsAnswered: 300, CallsAbandoned: 5, WarningLevel: 0, WarningTime: "" },
                { Name: 'Group 7', CallsWaiting: 0, MaxWaitTime: "00:00:00", CallsAnswered: 500, CallsAbandoned: 20, WarningLevel: 0, WarningTime: "" },
              ]
            });
        }
        else if (location.toUpperCase() === "LA") {
            return of({
              Name: "Skillset Rollup - LA",
              Location: "la",
              LastUpdated: "",
              IsAlert: true,
              Items: [
                { Name: 'Group 1', CallsWaiting: this.GetRandomCallWaiting(3, 0, 5, 5), MaxWaitTime: "00:02:10", CallsAnswered: 200, CallsAbandoned: 25, WarningLevel: 2, WarningTime: "" },
                { Name: 'Group 2', CallsWaiting: 1, MaxWaitTime: "00:01:25", CallsAnswered: 200, CallsAbandoned: 5, WarningLevel: 1, WarningTime: "" },
                { Name: 'Group 3', CallsWaiting: 1, MaxWaitTime: "00:01:10", CallsAnswered: 150, CallsAbandoned: 0, WarningLevel: 1, WarningTime: "" },
                { Name: 'Group 4', CallsWaiting: 0, MaxWaitTime: "00:00:00", CallsAnswered: 250, CallsAbandoned: 1, WarningLevel: 0, WarningTime: "" },
                { Name: 'Group 5', CallsWaiting: 0, MaxWaitTime: "00:00:00", CallsAnswered: 50, CallsAbandoned: 1, WarningLevel: 0, WarningTime: "" },
                { Name: 'Group 6', CallsWaiting: 0, MaxWaitTime: "00:00:00", CallsAnswered: 300, CallsAbandoned: 5, WarningLevel: 0, WarningTime: "" },
                { Name: 'Group 7', CallsWaiting: 0, MaxWaitTime: "00:00:00", CallsAnswered: 500, CallsAbandoned: 20, WarningLevel: 0, WarningTime: "" },
              ]
            });
        }
        return of({
          Name: "Skillset Rollup - Email",
          Location: "email",
          LastUpdated: "",
          IsAlert: true,
          Items: [
            { Name: 'Group 1', CallsWaiting: this.GetRandomCallWaiting(15, 0, 10, 6), MaxWaitTime: "01:05:10", CallsAnswered: 300, CallsAbandoned: 5, WarningLevel: 2, WarningTime: "" },
            { Name: 'Group 2', CallsWaiting: this.GetRandomCallWaiting(10, 0, 8, 3), MaxWaitTime: "00:52:10", CallsAnswered: 200, CallsAbandoned: 1, WarningLevel: 2, WarningTime: "" },
            { Name: 'Group 3', CallsWaiting: this.GetRandomCallWaiting(8, 0, 8, 5), MaxWaitTime: "00:25:10", CallsAnswered: 150, CallsAbandoned: 0, WarningLevel: 1, WarningTime: "" },
            { Name: 'Group 4', CallsWaiting: 0, MaxWaitTime: "00:00:00", CallsAnswered: 250, CallsAbandoned: 1, WarningLevel: 0, WarningTime: "" },
            { Name: 'Group 5', CallsWaiting: 0, MaxWaitTime: "00:00:00", CallsAnswered: 50, CallsAbandoned: 1, WarningLevel: 0, WarningTime: "" },
            { Name: 'Group 6', CallsWaiting: 0, MaxWaitTime: "00:00:00", CallsAnswered: 300, CallsAbandoned: 5, WarningLevel: 0, WarningTime: "" },
            { Name: 'Group 7', CallsWaiting: 0, MaxWaitTime: "00:00:00", CallsAnswered: 500, CallsAbandoned: 20, WarningLevel: 0, WarningTime: "" },
          ]
        });
    }
  }

  export interface ISkillsetRollup {
    Name: string,
    Location: string,
    LastUpdated: string,
    IsAlert: boolean,
    Items: ISkillsetRollupItem[]
  }

  interface ISkillsetRollupItem {
    Name: string,
    CallsWaiting: number,
    MaxWaitTime: string,
    CallsAnswered: number,
    CallsAbandoned: number,
    WarningLevel: number,
    WarningTime: string
  }

